(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pv-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',event=>{const form=event.target;if(!(form instanceof HTMLFormElement)||!form.matches('[data-pv-tag-form]'))return;const tags=[...form.querySelectorAll('[data-pv-tag-choice]')].map(input=>input.value).filter(Boolean);form.action=form.dataset.collectionUrl+(tags.length?'/'+tags.map(encodeURIComponent).join('+'):'');});

document.addEventListener('click',event=>{const close=event.target.closest('[data-pv-filter-close]');if(close){const menu=close.closest('.pv-filter-disclosure');menu.open=false;menu.querySelector('summary').focus();}document.querySelectorAll('.pv-filter-disclosure[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.pv-filter-disclosure[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-gallery-viewer"] && !Shopify.designMode) return;
  try {
    function setupPVGallery(scope=document){
 scope.querySelectorAll('[data-pv-gallery-open]').forEach(opener=>{
  if(opener.dataset.ready)return;
  opener.dataset.ready='true';
  const section=opener.closest('.pv-collection');
  const dialog=opener.nextElementSibling;
  const pool=section?.querySelector('template[data-pv-gallery-pool]');
  if(!pool||!dialog?.matches('dialog')){opener.hidden=true;return;}
  const parse=template=>[...template.content.querySelectorAll('a[data-image]')].map(a=>({url:a.getAttribute('href'),image:a.dataset.image,title:a.dataset.title}));
  const items=parse(pool);
  if(!items.length){opener.hidden=true;return;}
  let index=0,shown=-1,request=0,nextPage=pool.dataset.next||'',pagePromise=null;
  const link=dialog.querySelector('.pv-gallery-image-link');
  const picture=dialog.querySelector('img');
  const previous=dialog.querySelector('[data-pv-gallery-prev]');
  const next=dialog.querySelector('[data-pv-gallery-next]');
  const close=dialog.querySelector('[data-pv-gallery-close]');
  const controls=()=>{previous.disabled=index===0;next.disabled=index===items.length-1&&!nextPage;};
  const more=async()=>{
   if(!nextPage)return;
   if(!pagePromise)pagePromise=(async()=>{
    const response=await fetch(nextPage,{credentials:'same-origin'});
    if(!response.ok)throw new Error('page');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const template=doc.querySelector('template[data-pv-gallery-pool]');
    if(!template)throw new Error('pool');
    items.push(...parse(template));nextPage=template.dataset.next||'';
   })().finally(()=>{pagePromise=null;});
   return pagePromise;
  };
  const show=async target=>{
   const token=++request;dialog.setAttribute('aria-busy','true');
   try{
    let attempts=0;while(target>=items.length&&nextPage&&attempts<12){await more();attempts++;}
    if(token!==request||!dialog.open)return;
    index=Math.max(0,Math.min(target,items.length-1));controls();
    const item=items[index],image=new Image();image.src=item.image;await image.decode();
    if(token!==request||!dialog.open)return;
    picture.width=image.naturalWidth;picture.height=image.naturalHeight;picture.src=item.image;picture.alt=item.title;link.href=item.url;shown=index;
    const upcoming=items[index+1];if(upcoming){const preload=new Image();preload.src=upcoming.image;}
   }catch{index=Math.max(0,shown);controls();}
   finally{if(token===request)dialog.removeAttribute('aria-busy');}
  };
  opener.addEventListener('click',()=>{if(!window.matchMedia('(min-width:801px)').matches)return;dialog.showModal();document.documentElement.classList.add('pv-gallery-is-open');close.focus();show(index);});
  close.addEventListener('click',()=>dialog.close());
  previous.addEventListener('click',()=>show(index-1));next.addEventListener('click',()=>show(index+1));
  dialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();if(event.key==='ArrowLeft'&&!previous.disabled)show(index-1);if(event.key==='ArrowRight'&&!next.disabled)show(index+1);}});
  dialog.addEventListener('close',()=>{request++;dialog.removeAttribute('aria-busy');document.documentElement.classList.remove('pv-gallery-is-open');opener.focus();});
  window.addEventListener('pageshow',()=>{if(dialog.open)dialog.close();});
  controls();
 });
}
setupPVGallery();document.addEventListener('shopify:section:load',event=>setupPVGallery(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-grid-toggle"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pv-grid-toggle'))customElements.define('pv-grid-toggle',class extends HTMLElement{
 connectedCallback(){
  this.root=this.closest('.pv-collection-results');if(!this.root)return;
  let columns='4';try{if(localStorage.getItem('pv-grid-columns')==='2')columns='2';}catch{}
  this.apply(columns);
  this.onclick=event=>{const button=event.target.closest('button[data-columns]');if(!button||!this.contains(button))return;this.apply(button.dataset.columns);try{localStorage.setItem('pv-grid-columns',button.dataset.columns);}catch{}};
  const grid=this.root.querySelector('.pv-collection-grid');if(grid){this.observer=new MutationObserver(()=>this.resize());this.observer.observe(grid,{childList:true});}
 }
 disconnectedCallback(){this.observer?.disconnect();}
 apply(columns){this.root.dataset.pvColumns=columns;this.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.columns===columns)));this.resize();}
 resize(){this.root.querySelectorAll('.pv-art-media>a>img').forEach(img=>{if(!img.dataset.pvOriginalSizes)img.dataset.pvOriginalSizes=img.sizes;img.sizes=this.root.dataset.pvColumns==='2'?'(max-width: 800px) calc((100vw - 56px) / 2), (max-width: 1500px) 44vw, 680px':img.dataset.pvOriginalSizes;});}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-header-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{document.querySelectorAll('.pv-langpill[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.pv-langpill[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
document.addEventListener('toggle',event=>{if(event.target.matches?.('.pv-langpill')&&event.target.open){document.querySelectorAll('.pv-nav-item[open]').forEach(menu=>menu.open=false);}if(event.target.matches?.('.pv-nav-item')&&event.target.open){document.querySelectorAll('.pv-langpill[open]').forEach(menu=>menu.open=false);}},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-load-more"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pv-load-more'))customElements.define('pv-load-more',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  this.ready=true;
  this.grid=this.closest('.pv-collection-results')?.querySelector('.pv-collection-grid');
  if(!this.grid)return;
  this.button=this.querySelector('button');this.status=this.querySelector('[role="status"]');this.fallback=this.querySelector('[data-pv-pagination-fallback]');
  this.next=this.dataset.next||'';this.queue=[];this.seen=new Set([...this.grid.children].map(c=>c.dataset.pvProduct));this.pages=new Set();
  this.button.addEventListener('click',()=>this.load(24,true));
  this.load(Math.max(0,24-this.grid.children.length),false);
 }
 async page(){
  const url=new URL(this.next,location.href);
  if(url.origin!==location.origin||this.pages.has(url.href))throw new Error('pagination');
  const key=url.href;url.searchParams.set('section_id',this.dataset.section);
  const response=await fetch(url,{credentials:'same-origin'});
  if(!response.ok)throw new Error('network');
  const doc=new DOMParser().parseFromString(await response.text(),'text/html');
  const grid=doc.querySelector('.pv-collection-grid'),more=doc.querySelector('pv-load-more');
  if(!grid||!more)throw new Error('section');
  for(const card of grid.children){const id=card.dataset.pvProduct;if(id&&!this.seen.has(id)){this.seen.add(id);this.queue.push(card);}}
  this.pages.add(key);this.next=more.dataset.next||'';
 }
 async load(amount,requested){
  if(this.busy)return;this.busy=true;this.button.disabled=true;this.button.textContent=this.dataset.loading;this.setAttribute('aria-busy','true');
  if(requested)this.status.textContent=this.dataset.loading;
  try{
   let pages=0;while(this.queue.length<amount&&this.next&&pages<12){await this.page();pages++;}
   const cards=this.queue.splice(0,amount),fragment=document.createDocumentFragment();
   for(const card of cards)fragment.append(card);
   this.grid.append(fragment);this.fallback.hidden=false;
   this.status.textContent=requested?this.dataset.count.replace('[count]',String(this.grid.children.length)):'';
   this.dispatchEvent(new CustomEvent('pv:products-added',{bubbles:true}));
  }catch{this.fallback.hidden=false;if(requested)this.status.textContent=this.dataset.error;}
  finally{this.busy=false;this.button.disabled=false;this.button.textContent=this.dataset.label;this.button.hidden=!this.next&&!this.queue.length;this.removeAttribute('aria-busy');}
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-multibuy-offer"] && !Shopify.designMode) return;
  try {
    function updatePVMultiBuyAmounts(scope=document){
  const currency=window.Shopify?.currency;
  scope.querySelectorAll('[data-pv-discount-base]').forEach(offer=>{
    const target=offer.dataset.pvDiscountCurrency;
    const rate=target==='SEK'?1:(currency?.active===target?Number(currency.rate):NaN);
    if(!Number.isFinite(rate)||rate<=0)return;
    try{
      const amount=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:target,currencyDisplay:['SEK','NOK','DKK'].includes(target)?'code':'symbol',minimumFractionDigits:0,maximumFractionDigits:2}).format(Number(offer.dataset.pvDiscountBase)*rate);
      offer.querySelector('[data-pv-discount-amount]').textContent=offer.dataset.pvDiscountTitle.replace('__PV_AMOUNT__',amount);
    }catch{}
  });
}
updatePVMultiBuyAmounts();
document.addEventListener('shopify:section:load',event=>updatePVMultiBuyAmounts(event.target));
window.addEventListener('pageshow',()=>updatePVMultiBuyAmounts());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-pv-quick-open]');
  if (opener) {
    event.preventDefault();
    const card = opener.closest('.pv-art-card');
    const panel = card && card.querySelector('[data-pv-quick]');
    if (!panel) return;
    document.querySelectorAll('[data-pv-quick]:not([hidden])').forEach((p) => { if (p !== panel) p.hidden = true; });
    panel.hidden = false;
    return;
  }

  const closer = event.target.closest('[data-pv-quick-close]');
  if (closer) {
    const panel = closer.closest('[data-pv-quick]');
    if (panel) panel.hidden = true;
    return;
  }

  const size = event.target.closest('[data-pv-quick] [data-pv-size]');
  if (size) {
    const panel = size.closest('[data-pv-quick]');
    panel.querySelectorAll('[data-pv-size]').forEach((b) => {
      b.classList.toggle('is-active', b === size);
      b.setAttribute('aria-selected', b === size ? 'true' : 'false');
    });
    panel.querySelector('[data-pv-quick-total]').textContent = size.dataset.price;
    panel.querySelector('[data-pv-atc]').dataset.pvAtc = size.dataset.variant;
    return;
  }

  if (!event.target.closest('[data-pv-quick]')) {
    document.querySelectorAll('[data-pv-quick]:not([hidden])').forEach((p) => { p.hidden = true; });
  }
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-pv-quick] [data-pv-atc]');
  if (!button) return;
  event.preventDefault();
  if (button.dataset.busy === '1') return;
  button.dataset.busy = '1';
  const label = button.textContent;
  button.disabled = true;
  button.textContent = button.dataset.adding;
  const status = button.closest('[data-pv-quick]').querySelector('[data-pv-quick-status]');
  status.textContent = '';
  const root = window.Shopify.routes.root;
  try {
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.pvAtc), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error('add failed');
    button.textContent = button.dataset.added;
    window.location.href = root + 'cart';
  } catch (error) {
    status.textContent = button.dataset.addError;
    button.textContent = label;
    button.disabled = false;
    button.dataset.busy = '';
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-room-hover"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pv-room-image')){
 const desktop=matchMedia('(hover:hover) and (pointer:fine)'),queue=[],recent=new Map(),assigned=new Map();let active=0;
 const choose=(family,id,count)=>{const key=family+':'+id;if(assigned.has(key))return assigned.get(key)%count;const used=recent.get(family)||[];let hash=0;for(const char of id)hash=(hash*31+char.charCodeAt(0))>>>0;let n=hash%count;for(let i=0;i<count&&used.includes(n);i++)n=(n+1)%count;assigned.set(key,n);recent.set(family,[...used,n].slice(-Math.min(4,count-1)));return n;};
 const pump=()=>{while(active<2&&queue.length){const element=queue.shift();if(!element.isConnected)continue;active++;element.load().finally(()=>{active--;pump();});}};
 const observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){observer.unobserve(entry.target);entry.target.schedule();}}},{rootMargin:'0px'});
 customElements.define('pv-room-image',class extends HTMLElement{
  connectedCallback(){
   if(!desktop.matches)return;
   this.card=this.closest('.pv-art-card');this.intent=()=>this.schedule(true);
   this.card?.addEventListener('pointerenter',this.intent);this.card?.addEventListener('focusin',this.intent);
   this.start=()=>{
    if(!this.isConnected||navigator.connection?.saveData||/2g/.test(navigator.connection?.effectiveType||''))return;
    const observe=()=>{if(this.isConnected)observer.observe(this);};
    if('requestIdleCallback' in window)requestIdleCallback(observe,{timeout:1500});else setTimeout(observe,100);
   };
   if(document.readyState==='complete')this.start();else window.addEventListener('load',this.start,{once:true});
  }
  disconnectedCallback(){observer.unobserve(this);window.removeEventListener('load',this.start);this.card?.removeEventListener('pointerenter',this.intent);this.card?.removeEventListener('focusin',this.intent);}
  schedule(urgent=false){
   if(this.hasAttribute('data-ready'))return;
   if(this.queued){if(urgent){const index=queue.indexOf(this);if(index>=0){queue.splice(index,1);queue.unshift(this);}}return;}
   this.queued=true;if(urgent)queue.unshift(this);else queue.push(this);pump();
  }
  async load(){
   const template=this.querySelector('template');if(!template)return;
   const content=template.content.cloneNode(true),background=content.querySelector('[data-scenes]');
   const primary=this.closest('.pv-art-media')?.querySelector('a>img');
   const art=content.querySelector('.pv-hover-frame [data-src]');
   const primarySrc=primary?.complete&&primary.naturalWidth?(primary.currentSrc||primary.src):'';
   try{if(art&&primarySrc&&new URL(primarySrc,location.href).pathname===new URL(art.dataset.src,location.href).pathname)art.dataset.src=primarySrc;}catch{}
   try{
    if(background){
     let scenes=JSON.parse(background.dataset.scenes);let family=this.dataset.family;
     const darkRooms=JSON.parse(this.dataset.darkRooms||'[]');
     if(family!=='kids'&&darkRooms.length&&art){
      if(customElements.get('pv-toned-room')?.isDarkImage(primary,this.dataset.crop==='true')){scenes=darkRooms;family='dark';this.dataset.dark='true';}
     }
     if(!scenes.length)return;const n=choose(family,this.dataset.product,scenes.length);background.dataset.src=scenes[n];this.dataset.scene=String(n+1);
    }
    this.append(content);
    const pending=[...this.querySelectorAll('img,svg image')].map(element=>{
     const source=element.dataset.src;
     if(element.tagName.toLowerCase()==='image'&&source===primarySrc){element.setAttribute('href',source);return Promise.resolve();}
     if(element.tagName.toLowerCase()==='image')return new Promise((resolve,reject)=>{const preload=new Image();preload.onload=()=>{element.setAttribute('href',source);resolve();};preload.onerror=reject;preload.src=source;});
     if(source)element.src=source;
     return element.decode();
    });
    await Promise.all(pending);
    if(this.isConnected)this.setAttribute('data-ready','');
   }catch{for(const child of [...this.children])if(child.tagName!=='TEMPLATE')child.remove();this.queued=false;}
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-room-tone"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pv-toned-room')){
 const cache=new Map();
 const idle=callback=>{if('requestIdleCallback' in window)requestIdleCallback(callback,{timeout:1500});else setTimeout(callback,100);};
 const near=new IntersectionObserver(entries=>{for(const entry of entries)if(entry.isIntersecting){near.unobserve(entry.target);idle(()=>entry.target.load());}},{rootMargin:'0px'});
 customElements.define('pv-toned-room',class extends HTMLElement{
  static isDarkImage(image,crop=false){
   if(!image?.complete||!image.naturalWidth)return null;
   const key=(image.currentSrc||image.src)+':'+crop;if(cache.has(key))return cache.get(key);
   try{
    const canvas=document.createElement('canvas');canvas.width=24;canvas.height=24;
    const ctx=canvas.getContext('2d',{willReadFrequently:true});if(!ctx)return null;
    const w=image.naturalWidth,h=image.naturalHeight;
    if(crop&&w===h)ctx.drawImage(image,w*316/2048,h*33/2048,w*1418/2048,h*1986/2048,0,0,24,24);
    else ctx.drawImage(image,w*.07,h*.07,w*.86,h*.86,0,0,24,24);
    const pixels=ctx.getImageData(0,0,24,24).data;let sum=0,dark=0,count=0;
    for(let i=0;i<pixels.length;i+=4){if(pixels[i+3]<128)continue;const light=(.2126*pixels[i]+.7152*pixels[i+1]+.0722*pixels[i+2])/255;sum+=light;dark+=light<.38?1:0;count++;}
    const result=count>0&&sum/count<.36&&dark/count>.6;
    if(cache.size>500)cache.clear();cache.set(key,result);return result;
   }catch{return null;}
  }
  connectedCallback(){
   this.start=()=>{if(this.isConnected)near.observe(this);};
   if(document.readyState==='complete')this.start();else window.addEventListener('load',this.start,{once:true});
  }
  disconnectedCallback(){near.unobserve(this);window.removeEventListener('load',this.start);}
  load(){
   if(this.loaded||this.dataset.family==='kids')return;this.loaded=true;
   const background=this.querySelector('.pv-room-scene__background');if(!background)return;
   try{
    const path=new URL(this.dataset.artSource,location.href).pathname;
    const artwork=[...document.images].find(image=>image.complete&&image.naturalWidth&&new URL(image.currentSrc||image.src,location.href).pathname===path);
    const rooms=JSON.parse(this.dataset.darkRooms||'[]');
    if(rooms.length&&this.constructor.isDarkImage(artwork,this.dataset.crop==='true')){
     const source=rooms[Number(this.dataset.product)%rooms.length];
     background.removeAttribute('srcset');background.src=source;this.dataset.dark='true';
    }
   }catch{}
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-size-scale"] && !Shopify.designMode) return;
  try {
    function initPrintavelleScale(scope=document){scope.querySelectorAll('[data-pv-scale]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const height=root.querySelector('[data-height]'),size=root.querySelector('[data-size]');function draw(){const h=Number(height.value),[w,p]=size.value.split(',').map(Number);if(!height.checkValidity()||!Number.isFinite(h)||h<100||h>220)return;root.querySelector('[data-person]').setAttribute('transform',`translate(${60-20*h/174} ${225-h}) scale(${h/174})`);const rect=root.querySelector('[data-print]');rect.setAttribute('x',162.5-w/2);rect.setAttribute('y',105-p/2);rect.setAttribute('width',w);rect.setAttribute('height',p);root.querySelector('[data-size-label]').textContent=`${w} × ${p} cm`;root.querySelector('[data-height-label]').textContent=`${h} cm`;}height.addEventListener('input',draw);size.addEventListener('change',draw);draw();});}initPrintavelleScale();document.addEventListener('shopify:section:load',event=>initPrintavelleScale(event.target));
  } catch(e) { console.error(e); }
})();

})();
